// eslint-disable-next-line no-shadow
export enum viewRightSideBarEnum {
  empty = -1,
  addDevice,
  singletonDevice,
  staticDevice,
  editMultipleDevices,
  deviceAnnounce,
  postDebug,
  details,
  editUserPermissions,
  manageUserRoles,
  createUserRole,
  addAdmin,
  editUserAndRole,
  editMultipleUsers,
  addSystemUser,
  addFolders,
  assignUsersInBusinessAccount,
  addBusinessAccount,
  addDeviceToLocation,
  addUserToLocation,
  addLocation,
  assignLocation,
  addOrganization,
  assignLocationToOrg,
  locationDetails,
  transferLocation,
  shareLocation,
  moveLocation,
  multipleLocationsDetails,
  multipleScheduleMethodsDetails,
  addDeviceMethodFromTemplate,
  organizationDetails,
  multipleOrganizationsDetails,
  SetWifiCredentials,
  sendFileThroughEmail,
  businessAccountDetails,
  addUserToBusinessAccount,
  usersInBusinessDetails,
  filters,
  createUserBusinessAccount,
  locationDetailsBusinessAccount,
  addNote,
  noteDetails,
  editNote,
  shareLocationsWithTargets,
  changeUserPassword,
  scheduleFirmwareFilters,
  allLocationsFilters,
  userLocationsAndOrgFilters,
  singleUserActivation,
  multipleUserActivation,
  manageAuthorizedApps,
  singlePartNumber,
  createPartNumber,
  createShippingOrder,
  singleShippingOrder,
  addSippingOrder
}
